import { render, staticRenderFns } from "./FinalQuestions.vue?vue&type=template&id=4b4eb94e&scoped=true&"
import script from "./FinalQuestions.vue?vue&type=script&lang=js&"
export * from "./FinalQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FinalQuestions.vue?vue&type=style&index=0&id=4b4eb94e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4eb94e",
  null
  
)

export default component.exports